import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../app/stores/rootStore";
import React, { useContext, useEffect, useRef } from "react";
// reactstrap components
import { Row, Col, Button } from "reactstrap";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ArchiveTreeComponent from "../components/archive/ArchiveTreeComponent";
import { contentTipology } from "../app/models/node";
import ArchiveTreeIcon from "../components/archive/ArchiveTreeIcon";
import { EventDataNode } from "rc-tree/lib/interface";
import { safeEncodeURIComponent } from "../app/helpers/urlHelper";

const STYLE = `
.rc-tree-child-tree {
  display: block;
}
.node-motion {
  transition: all .3s;
  overflow-y: hidden;
}
`;
const ArchivePage: React.FC<RouteComponentProps> = ({ history }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { loadArchives, archivesArray, setAutoOpeningFolder } =
    rootStore.archiveStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const { isMobileMediaQuery } = rootStore.responsiveStore;
  const link = useRef<null | HTMLAnchorElement>(null);
  
  const treeIconComponent = (nodeKey: string, hasDocument?: boolean, type?: contentTipology, hasChildren? : boolean, expandedByDefault?: boolean) => {
    return (
      <ArchiveTreeIcon nodeKey ={nodeKey} hasDocument ={hasDocument} type={type} hasChildren={hasChildren} expandedByDefault= {expandedByDefault}></ArchiveTreeIcon>
    )
  }
 
  const handleSelect= (node: any) => {
    if(node.children && node.children.length > 0) return;
    history.push(`archives/${node.key.toString()}`)
  }

  useEffect(() => {
    setAutoOpeningFolder(undefined);
  },[]);

  useEffect(() => {
    loadArchives()
      .then((res) => {
        const scrollableElement = document.querySelector(".odgPage");
        if (scrollableElement) disableBodyScroll(scrollableElement);
      })
      .catch();
    return () => {
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [loadArchives]);

  return (
    <>
      <div className="odgPage">
        <style dangerouslySetInnerHTML={{ __html: STYLE }} />
        <div
          className={classnames(
            "parent",
            `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
          )}
        >
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "left margin-right-auto",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
            {t("archive_page_title_bar",{ns: "translation"})}
          </div>
          <div
            className={classnames(
              isMobileMediaQuery
                ? "odgTitoloRepositoryMobile"
                : "odgTitoloRepository",
              "right",
              `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
            )}
          >
          </div>
        </div>
        <Row>
          <Col xs={12} className="odgContainer">
            {archivesArray && archivesArray.length > 0 && (
              <ArchiveTreeComponent
                dataArray={archivesArray}
                handleSelect= {handleSelect}
                treeIconComponent={treeIconComponent}
              ></ArchiveTreeComponent>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default observer(ArchivePage);
